import React from 'react';
import { Card, SpinnerIcon } from '@avila-tek/ui/src';
import { Title } from '../../shared';
import LeaderBoardRow from './LeaderBoardRow';
import Empty from '../Charts/Empty';

export type LeaderBoardItem = {
  amount: number;
  photoSrc: string;
  name: string;
};
interface LeaderBoardProps {
  data: LeaderBoardItem[];
  loading: boolean;
  title: string;
  amountType: 'number' | 'money';
}

function LeaderBoard({ data, loading, title, amountType }: LeaderBoardProps) {
  return (
    <Card className="w-full p-4 px-6 h-full ">
      <Title title={title} />
      {!loading ? (
        <div className="flex h-full flex-col">
          {data?.length > 0 ? (
            data.map((item, i) => (
              <LeaderBoardRow
                key={`${item?.name}-${i}`}
                name={item?.name}
                amount={item?.amount}
                amountType={amountType}
                photoSrc={item?.photoSrc ?? ''}
              />
            ))
          ) : (
            <Empty />
          )}
        </div>
      ) : (
        <SpinnerIcon className="m-auto w-24 h-24 text-gray-200 animate-spin fill-purple-300" />
      )}
    </Card>
  );
}

export default LeaderBoard;
